import { stopAllStreams as stopAll, stopStream as stopSingle } from './mediaManager';

export function TurnOffCamera() {
  try {
    // Prevent rapid repeated invocations from producing noisy logs and redundant work.
    try {
      const now = Date.now();
      const last = (window as any).__TurnOffCamera_lastInvoked || 0;
      // if called within 800ms, skip
      if (now - last < 800) return;
      (window as any).__TurnOffCamera_lastInvoked = now;
    } catch (_) {}

    // If mediaManager reports no active streams AND there are no <video> elements with srcObject, skip heavy work.
    try {
      const mgr = (window as any).__mediaManager;
      const list = typeof mgr?.listStreams === 'function' ? (mgr.listStreams() || []) : [];
      const vids = Array.from(document.querySelectorAll('video')) as HTMLVideoElement[];
      const anyVideoHasStream = vids.some(v => !!(v && (v.srcObject as MediaStream | null)));
      if ((!list || list.length === 0) && !anyVideoHasStream) {
        // nothing to stop — avoid noisy debug prints
        return;
      }
    } catch (_) {}

    // Prefer the mediaManager global stop
    try { stopAll(); } catch (e) { /* ignore */ }
    try { console.debug('[TurnOffCamera] invoked - called stopAllStreams'); } catch (_) {}

    // Defensive: stop tracks on all <video> elements present
    try {
      const vids = Array.from(document.querySelectorAll('video')) as HTMLVideoElement[];
      vids.forEach(v => {
        try {
          const s = v.srcObject as MediaStream | null;
          if (s) {
            try { stopSingle(s); } catch (_) {
              try { s.getTracks().forEach(t => { try { t.stop(); } catch (_) {} }); } catch (_) {}
            }
            try { v.srcObject = null; } catch (_) {}
          }
          try { v.pause(); } catch (_) {}
        } catch (_) {}
      });
    } catch (_) {}
    try {
      // small delay then log tracked streams for debugging
      setTimeout(() => {
        try { console.debug('[TurnOffCamera] post-stop mediaManager.listStreams:', (window as any).__mediaManager ? (window as any).__mediaManager.listStreams() : null); } catch (_) {}
      }, 50);
    } catch (_) {}
  } catch (_) {}
}

// Expose helper for console convenience
try {
  if (typeof window !== 'undefined') (window as any).TurnOffCamera = TurnOffCamera;
} catch (_) {}

export default TurnOffCamera;
